export const voucherSaleContent = `
<!DOCTYPE html>
<html lang="es">
<head>
<meta charset="UTF-8">
<title>Comprobante de Pago</title>
<style>
  body {
    font-family: Arial, sans-serif;
    margin: 40px;
    color: #333;
    font-size: 14px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .header-left p {
    margin: 2px 0;
    line-height: 1.4;
  }

  .header-left strong {
    font-size: 16px;
  }

  .header-left .bold {
    font-weight: bold;
  }

  .header-right {
    text-align: right;
    font-weight: bold;
    font-size: 14px;
  }

  .header-right p {
    margin: 2px 0;
    line-height: 1.2;
  }

  .header-right strong {
    font-size: 18px; /* Número de operación más grande */
  }

  .amount {
    background-color: #f5f5f5;
    padding: 20px;
    text-align: center;
    margin: 20px 0;
  }

  .amount p:first-child { /* "Monto de Pago" */
    font-size: 18px;
    margin: 3px 0;
  }

  .amount h2 {
    font-size: 36px; /* Monto aún más grande */
    color: #2d54af;
    margin: 5px 0;
    font-weight: bold;
  }

  .amount p {
    margin: 3px 0;
  }

  .details-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    row-gap: 10px;
    column-gap: 20px;
    margin-top: 20px;
    font-size: 14px;
  }

  .details-item .label {
    font-weight: normal;
    color: #555;
    margin: 0;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
  }

  .details-item .value {
    margin: 0;
    font-weight: normal;
    line-height: 1.4;
  }

  .footer {
    margin-top: 20px;
    font-size: 13px;
  }

  .footer p {
    margin: 5px 0;
    color: #777; /* Texto de la nota final en gris */
  }

  .footer strong {
    font-weight: bold;
  }

  .pre-estimado {
    margin-top: 40px; /* Espaciado adicional antes de “Estimado cliente” */
  }

  .gray-text { /* Para los textos "Informamos que..." y "Este comprobante..." */
    color: #777;
  }
  
  .color-neutral-darker {
	color: #535353 !important;
  }
</style>
</head>
<body>

<div class="header">
  <div class="header-left color-neutral-darker">
    <p>Santiago, [format_date]</p>
    <p><strong>[merchant_name]</strong></p>
    <p class="bold">RUT [merchant_rut]</p>
    <p class="bold">[merchant_address]</p>
  </div>
  <div class="header-right">
    <p>N° de Operación</p>
    <p><strong>[operation_number]</strong></p>
  </div>
</div>

<div class="pre-estimado"></div>

<p class="color-neutral-darker"><strong>Estimado cliente,</strong></p>
<p class="gray-text">Informamos que su compra ha sido procesada exitosamente.<br>A continuación, se presentan los antecedentes:</p>

<div class="amount">
  <p>Monto de Pago</p>
  <h2>[amount]</h2>
  <p>Estado: [status]</p>
</div>

<div class="details-grid">
  <div class="details-item">
    <p class="label">Código de autorización</p>
    <p class="value">[authorization_code]</p>
  </div>
  <div class="details-item">
    <p class="label">Fecha de venta</p>
    <p class="value">[created_at]</p>
  </div>
  <div class="details-item">
    <p class="label">Tipo de transacción</p>
    <p class="value">[operation_type]</p>
  </div>
  <div class="details-item">
    <p class="label">Nombre comercio</p>
    <p class="value"><strong>[branch_name]</strong></p>
  </div>
  <div class="details-item">
    <p class="label">Método de pago</p>
    <p class="value">[network_type]</p>
  </div>
  <div class="details-item">
    <p class="label">Últimos dígitos tarjeta</p>
    <p class="value">[lastfourdigit]</p>
  </div>
  <div class="details-item">
    <p class="label">Cuotas</p>
    <p class="value">[installment_count]</p>
  </div>
  <!--
  <div class="details-item">
    <p class="label">Propina</p>
    <p class="value">$ 0 CLP</p>
  </div>
  -->
</div>

<div class="footer">
  <p class="gray-text" style="margin-bottom: 20px;">Este comprobante respalda la ejecución efectiva de su pago. En caso de requerir información adicional, boleta o factura de su compra, favor de contactar a servicio de atención al cliente o dirigirse a la sucursal donde realizó la compra.</p>
  <p>Atentamente,<br><strong class="color-neutral-darker">[merchant_name]</strong></p>
</div>

</body>
</html>
`;